import React from "react";
import "../styles/AboutUsBanner.css";
import myvideo from '../assets/services-banner.mp4'

const ServicesBanner = () => {
  return (
    <section className="about-us-banner">
      <video
        className="aboutus-banner-video"
        src={myvideo}
        autoPlay
        loop
        muted
      ></video>
      <div className="aboutus-overlay">
        <div className="aboutus-content">
          <h1>Innovative Robotics & Automation Solutions Tailored for Every Industry</h1>
          <p>From system concepts to turnkey project management, we deliver cutting-edge solutions that drive productivity and efficiency</p>
        </div>
      </div>
    </section>
  );
};

export default ServicesBanner;
